module.exports = __webpack_public_path__ + "square.af35bab6.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/square.svg
// module id = z14X
// module chunks = 0